<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                @dblclick:row="(event, data) => onRowDblClick(data.item.id)"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
            >

                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                 <template v-slot:[`item.key`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.key">
                                {{ item.key }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.name">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.requisite_group`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.requisite_group">
                                {{ item.requisite_group }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.requisite_type`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text">
                                {{ getRequisiteTypeName(item.requisite_type) }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <div class="table-action-menu-col-with-header" v-on:click.stop.prevent>
                        <v-popover
                            trigger="click"
                        >
                            <v-chip
                                class="person-label"
                                small
                                label
                                color="orange lighten-3"
                            >
                                <v-icon color="#494F59">fas fa-ellipsis-v</v-icon>
                            </v-chip>

                            <template slot="popover">
                                <ul class="ribbon-button-submenu">
                                    <li 
                                        @click.stop="onDeleteRequisite(item.id)"
                                        v-close-popover
                                    >
                                        <v-icon left>fas fa-trash</v-icon>

                                        {{ $t('Удалить') }}
                                    </li>
                                </ul>
                                <span class="ribbon-button-submenu-title">{{ $t("Подменю_действий") }}</span>
                            </template>
                        </v-popover>
                    </div>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        </v-col>

    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";

export default {
    columnIndex:  {
        'requisite_group': 2,
        'name': 3,
        'key': 4
    },
    props: {
        search: {
            type: String,
            default: ""
        }
    },
    computed: {
        ...mapGetters('templates', { requisiteTypes: 'getRequisiteTypes' }),
        collection() {
            return this.$store.getters['templates/getCollection'];
        },
        headers() {
            return [
                { text: this.$t("Ключ"), value: 'key', width: '100px' },
                { text: this.$t("Наименование"), value: 'name' },
                { text: this.$t("Группа"), value: 'requisite_group', width: '300px' },
                { text: this.$t("Тип"), value: 'requisite_type', width: '100px', sortable: false},
                { text: '', value: 'actions', width: '36px', sortable: false }
            ];
        },
        options: {
            get: function() {
                let op = this.$store.getters['templates/requisites/getTableOptions'];
                return op;
            },
            set: function(newValue) {
                this.$store.commit('templates/requisites/SET_TABLE_OPTION', newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search
            }
        }
    },
    data() {
        return {
            loading: true,
            total: 0,
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        dateFormat: sys.dateFormat,
        resetPage() {
            this.$store.commit('templates/requisites/SET_TABLE_OPTION_PAGE', 1);
        },
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getSerializedFilter()))
                return;

            this.prevTableFilterObject = this.getSerializedFilter();
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/templates/list?collection=${this.collection}&filter=${this.getSerializedFilter()}`,
                method: 'GET',
                headers: { "isCommon": true }
            });

            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;
            this.loading = false;
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "name" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 3;

            return JSON.stringify({ 
                SearchStr,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            });
        },
        getRequisiteTypeName(requisiteTypeId) {
            let type = this.requisiteTypes.find(x => x.id == requisiteTypeId);
            return type?.value ?? "Не_указано";
        },
        async onRowDblClick(itemId) {
            try
            {
                this.setOverlayVisible({ visible: true });

                let response = await httpAPI({
                    url: `api/open?type=Documents.Requisite&id=${itemId}`,
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json', 'isCommon': true }
                });

                if (response)
                    this.$eventBus.$emit('on-templates-module-action', { action: 'OpenRequisite', object: response.data.payload.Data.Object });
            }
            finally
            {
                this.setOverlayVisible({ visible: false });
            }
        },
        async onDeleteRequisite(itemId) {
            this.$notify.confirm(
                this.$t('Вы_действительно_хотите_удалить_реквизит'),
                async () => {
                    try
                    {
                        this.setOverlayVisible({ visible: true });

                        let response = await httpAPI({
                            url: `api/delete?type=Documents.Requisite&id=${itemId}`,
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json', 'isCommon': true }
                        });

                        if (response)
                            await this.getData(true);
                    }
                    finally
                    {
                        this.setOverlayVisible({ visible: false });
                    }
                }
            );
        }
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        },
    },
}
</script>
